import { COLORS } from 'helpers/globals'
import { row, column, column22, column45 } from 'helpers/styles/grid'

export default {
  container: {
    padding: '.8rem 0 .8rem 0',
    borderBottom: `1px solid ${COLORS.quaternary}`,
    position: 'relative'
  },
  inputs: row,
  aLittlePadding: { padding: '0 .8rem' },
  generalInputs: {
    ...column45,
    padding: '0 1rem !important'
  },
  cameraInputs: {
    ...column,
    paddingLeft: '0 !important',
    paddingRight: '1rem'
  },
  CalculatorModel: {
    ...row,
    paddingBottom: '.4rem',
    lineHeight: '3.5rem'
  },
  label: {
    ...column22,
    paddingRight: '0 !important',
    marginRight: '0 !important',
    color: 'black'
  },
  modelLink: { textDecoration: 'underline' },
  cameraActions: {
    position: 'absolute',
    right: 9,
    top: 7,
    zIndex: 1,
    fontSize: '2rem',
    display: 'flex',
    '& a:not(:last-of-type)': { marginRight: '1rem' }
  },
  bottomRow: {
    display: props => props.showBottomInputRow ? 'block' : 'none'
  },
  lensContainer: {
    display: 'flex',
    padding: '0 .8rem',
    color: 'black'
  },
  lensLabel: {
    flex: '0 0 22%'
  },
  lensWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  colorPicker: {
    display: 'flex',
    padding: '0 .8rem .4rem .8rem',
    color: 'black',
    '& span': { width: '5rem' }
  }
}



// WEBPACK FOOTER //
// ./src/components/GeneralPanelContainer/style.js